import { useMutation, useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useTenantContext } from 'src/context/useTenantContext';
import { orgBilling, orgBillingCheckout, orgBillingPortal } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

export function useBilling(options: { pollWhileFree?: boolean } = {}) {
  const { orgSlug } = useTenantContext();
  return useQuery({
    queryKey: [QUERIES.BILLING, orgSlug],
    queryFn: () => orgBilling({ orgSlug }),
    enabled: Boolean(orgSlug),
    // Also the "polled at most every 5 minutes" of the order-quota banner.
    staleTime: 5 * 60_000,
    // After Polar's checkout redirect: poll until the webhook has made the org Pro.
    refetchInterval: (data) => (options.pollWhileFree && data?.plan !== 'pro' ? 2_000 : false),
  });
}

export function useStartCheckout() {
  const { orgSlug } = useTenantContext();
  const { i18n } = useTranslation();
  return useMutation({
    mutationFn: () => orgBillingCheckout({ locale: i18n.language.startsWith('vi') ? 'vi' : 'en' }, { orgSlug }),
    onSuccess: ({ url }) => window.location.assign(url),
  });
}

export function useOpenBillingPortal() {
  const { orgSlug } = useTenantContext();
  return useMutation({
    mutationFn: () => orgBillingPortal({ orgSlug }),
    onSuccess: ({ url }) => window.location.assign(url),
  });
}
